export default {
  "wrapper": "_wrapper_y4628_1"
};import "/tmp/202335-27-f4u3o6.n5w7q.css";